import React from 'react';
import styled from 'styled-components';
import {InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import ServiceCard from '../Components/ServiceCard';
import design from '../img/design.svg';
import intelligence from '../img/intelligence.svg';
import gamedev from '../img/game-dev.svg';
import frontend from "../img/frontend.png";
import backend from "../img/backend.png";
import mobile from "../img/mobile.png";


function ServicesSection() {
    return (
        <InnerLayout>
            <ServicesSectionStyled>
                <Title title={'Services'} span={'services'} />
                <div className="services">
                    <ServiceCard 
                        image={frontend} 
                        title={'Frontend'} 
                        paragraph={'Berpengalaman dalam bidang Frontend Developer menggunakan framework React.js, menggunakan state management seperti Redux, dan menggunakan library seperti Styled Components, React Router, dll.'}
                    />
                    <div className="mid-card">
                        <ServiceCard 
                            image={mobile} 
                            title={'Mobile Application'} 
                            paragraph={'Mampu membangun Hybird Application (Android/IOS)  menggunakan React Native. Menggunakan Redux sebagai state management, React Navigation sebagai navigasi, dan menggunakan Styled Components sebagai styling.'}
                        />
                    </div>
                    <ServiceCard 
                        image={backend} 
                        title={'Backend'} 
                        paragraph={'Mampu membangun Backend Application menggunakan Express.js, menggunakan REST API, menggunakan MySQL/Postgree/MongoDB sebagai database, dan menggunakan JWT sebagai authentication.'}
                    />
                </div>
            </ServicesSectionStyled>
        </InnerLayout>
    )
}

const ServicesSectionStyled = styled.section`
    .services{
        margin-top: 5rem;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 1.5rem;
        @media screen and (max-width:1000px){
            flex-direction: column;
        }
        @media screen and (max-width:950px){
            grid-template-columns: repeat(2, 1fr);
        }
        @media screen and (max-width:650px){
            grid-template-columns: repeat(1, 1fr);
        }
       
    }
`;

export default ServicesSection;
